import React, { useEffect, useState, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import cssClasses from "./MyTarget.module.css";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import action from "../../Redux Store/actions";
//Images
import targetIcon from "../../Assets/Images/targetIcon.svg";
import circle from "../../Assets/Images/circle.svg";
import TotalLeadsIcon from "../../Assets/Images/TotalLeads.svg";
import TotalAllomentsIcon from "../../Assets/Images/TotalAllotmentsIcon.svg";
import AgreementsIcon from "../../Assets/Images/TotalAgreements.svg";
import SiteVisitIcon from "../../Assets/Images/TotalSiteVisitIcon.svg";
import TotalTokensIcon from "../../Assets/Images/TotalTokensIcon.svg";

import {
  getTotalLeadsCount,
  getSiteVisitsCount,
  getTokensCount,
} from "../../Services/LeadService";
import Chart from "react-apexcharts";

const useStyles = makeStyles((theme) => ({}));
export default function Target() {
  const dispatch = useDispatch();
  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth.user);
  const [leadsCount, setLeadsCount] = useState(0);
  const [siteVisitsCount, setSiteVistsCount] = useState(0);
  const [allotmentsCount, setAllomentsCount] = useState(0);
  const [tokenCount, setTokenCount] = useState(0);
  const [totalAgreement, setTotalAgreement] = useState(0);
  const [chart, setChart] = useState({
    optionsRadial: {
      plotOptions: {
        radialBar: {
          startAngle: 0,
          endAngle: 360,
          hollow: {
            margin: 0,
            size: "80%",
            background: "#fff",
            image: undefined,
            imageOffsetX: 0,
            imageOffsetY: 0,
            position: "front",
            dropShadow: {
              enabled: true,
              top: 3,
              left: 0,
              blur: 4,
              opacity: 0.24,
            },
          },
          track: {
            background: "#fff",
            strokeWidth: "67%",
            margin: 0, // margin is in pixels
            dropShadow: {
              enabled: true,
              top: -3,
              left: 0,
              blur: 4,
              opacity: 0.35,
            },
          },

          dataLabels: {
            showOn: "always",
            name: {
              offsetY: -20,
              show: true,
              color: "#888",
              fontSize: "10px",
            },
            value: {
              formatter: function (val) {
                return val;
              },
              color: "#111",
              fontSize: "20px",
              show: true,
            },
          },
        },
      },
      fill: {
        type: "gradient",
        gradient: {
          shade: "dark",
          type: "horizontal",
          shadeIntensity: 0.5,
          gradientToColors: ["#1570EF"],
          inverseColors: true,
          opacityFrom: 1,
          opacityTo: 1,
          stops: [0, 100],
        },
      },
      stroke: {
        lineCap: "round",
      },
      labels: ["Individual Performace"],
    },
    seriesRadial: [70],
  });
  const navigate = useNavigate();
  const classes = useStyles();
  useEffect(() => {
    dispatch(action.activeMenu("mytarget"));
    console.log(loggedInUser);
    getTotalLeadsCount(loggedInUser?.cpId, loggedInUser?.fosId).then((resp) => {
      console.log({ resp });
      setLeadsCount(resp.count);
    });
    getSiteVisitsCount(loggedInUser?.cpId, loggedInUser?.fosId).then((resp) => {
      console.log({ resp });
      setSiteVistsCount(resp.count);
    });
    getTokensCount(loggedInUser?.cpId, loggedInUser?.fosId).then((resp) => {
      setTokenCount(resp.count);
    });
  }, []);

  return (
    <div className={cssClasses.wrapperPage}>
      <div className={cssClasses.wrapperHeader}>
        <div className={cssClasses.wrapperTitleUserName}>
          <div className={cssClasses.headerTitle}>Good Morning</div>
          <div
            className={cssClasses.loggedInUserName}
            title={loggedInUser.name}
          >
            {loggedInUser.name}
          </div>
        </div>
        {/* <div
          className={cssClasses.headerTitle}
          style={{ cursor: "pointer" }}
          onClick={() => {
            navigate("/Home/Profile");
          }}
        >
          Edit Profile
        </div> */}
      </div>
      <div className={cssClasses.wrapperCard}>
        <div className={cssClasses.wrapperCardBlock}>
          <img
            src={targetIcon}
            alt={"TargetIcon"}
            style={{ marginRight: "1rem" }}
          />
          <div className={cssClasses.titleYourPerformace}>Your Performance</div>
        </div>
        <div className={cssClasses.wrapperChartAndData}>
          <div className={cssClasses.wrapperData}>
            <div className={cssClasses.wrapperDataContent}>
              <img src={TotalLeadsIcon} alt={"circleIcon"} />
              <div className={cssClasses.headerTitle}>
                Total number of Leads
              </div>
              <div className={cssClasses.headerTitle}>{leadsCount}</div>
            </div>
            <div className={cssClasses.wrapperDataContent}>
              <img src={SiteVisitIcon} alt={"circleIcon"} />
              <div className={cssClasses.headerTitle}>
                Total number of site visits
              </div>
              <div className={cssClasses.headerTitle}>{siteVisitsCount}</div>
            </div>
            <div className={cssClasses.wrapperDataContent}>
              <img src={TotalAllomentsIcon} alt={"circleIcon"} />
              <div className={cssClasses.headerTitle}>
                Total number of allotments
              </div>
              <div className={cssClasses.headerTitle}>{allotmentsCount}</div>
            </div>
            <div className={cssClasses.wrapperDataContent}>
              <img src={TotalTokensIcon} alt={"circleIcon"} />
              <div className={cssClasses.headerTitle}>
                Total number of Tokens
              </div>
              <div className={cssClasses.headerTitle}>{tokenCount}</div>
            </div>
            <div className={cssClasses.wrapperDataContent}>
              <img src={AgreementsIcon} alt={"circleIcon"} />
              <div className={cssClasses.headerTitle}>
                Total number of Agreement
              </div>
              <div className={cssClasses.headerTitle}>{totalAgreement}</div>
            </div>
          </div>
          <div>
            <Chart
              options={chart.optionsRadial}
              series={chart.seriesRadial}
              type="radialBar"
              width={window.innerWidth > 820 ? 280 : 240}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
